import {
  FETCH_INBOX_BEGIN,
  FETCH_INBOX_SUCCESS,
  FETCH_INBOX_FAILURE
} from '../actions/inboxActions';

const initialState = {
  items: [],
  loading: false,
  error: null,
  success: null,
};

export default function inboxReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INBOX_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_INBOX_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.threads,
        totalItems: action.payload.totalItems,
      };
    case FETCH_INBOX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: []
      };

    default:
      return state;
  }
}
